import { SmartViewItemConfiguration } from '../gridSmartViews/types';
import { Filter } from '../gridFilters/types';
import { ViewConfiguration } from '../gridView/types';

export function convertSmartConfigToViewConfig<Col extends number, ColKey extends string>(
  smartConf: SmartViewItemConfiguration<Col, Filter<ColKey>>
): ViewConfiguration<Col, ColKey> {
  return {
    name: smartConf.viewName,
    type: smartConf.viewType,
    compactView: smartConf.isCompactView,
    ...smartConf,
  };
}

export function convertViewConfigToSmartConfig<Col extends number, ColKey extends string>(
  viewConf: ViewConfiguration<Col, ColKey>
): SmartViewItemConfiguration<Col, Filter<ColKey>> {
  return {
    viewName: viewConf.name,
    viewType: viewConf.type,
    isCompactView: viewConf.compactView,
    ...viewConf,
  };
}
